import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { FixedFooter, FixedHeader, LockerCells } from "../../../../reduxified"
import ErrorInfoModal from "../../../../Modals/ErrorInfoModal"
import LoadingInfoModal from "../../../../Modals/LoadingInfoModal"
import WarningInfoModal from "../../../../Modals/WarningInfoModal"
import YesNoInfoModal from "../../../../Modals/YesNoInfoModal"
import WaitingForLockerLock from "../../../../Modals/WaitingForLockerLock"
import { providerManager } from "../../../../../providers/providerManager"
import {
  LogoutUser,
  reportFBEvent,
  logScreenEnterance,
  setShipingPackageOrder,
  createShipingPackageOrder,
  openAndListenToSpecificLockerLock,
  resetLockersErrorsAttemptsOpened,
  setThankYouSubTitle,
  setShipingPackageLoading,
  clearShipingPackage,
  returnPackageOrder,
  onLoading_CancelOrderByCustomer,
  onCustomerReturnOrderCancel,
  validateShipingPackageNumber,
  validateAdidasPackageNumber,
} from "../../../../../actions"
import "./style.css"

class ShipingPackageSelectLocker extends Component {
  constructor(props) {
    super(props)
    this.INIT_STATE = {
      isClickWaiting: false,
      showYesNoInfoModal: false,
      isOpenedDoor: false,
      openedLocker: "",
      showPutToLockerCanceled: false,
      isCancelActionPressed: false,
    }
    this.state = this.INIT_STATE
  }

  componentDidMount() {
    this.props.logScreenEnterance("SHIPING_PACKAGE SELECT_LOCKER")
  }

  componentWillUnmount() {
    this.state = this.INIT_STATE
  }

  clearWait() {
    this.setState({ isClickWaiting: false })
  }

  async componentWillReceiveProps(newProps) {
    const {
      orderWasLoaded,
      openingErrorOccurred,
      openingDoorSuccess,
      see_you_again,
      order,
      lockersWithOpenStatusFromHw,
      stationId,
      createReturnError,
      isLoading,
      isCustomerCancelReturnOrder,
    } = newProps

    if (openingDoorSuccess && !orderWasLoaded && !this.state.isOpenedDoor) {
      //if (this.state.isOpenedDoor) {return}
      console.log(
        " *********@ CREATE  openingDoorSuccess && !orderWasLoaded && !this.state.isOpenedDoor"
      )
      const openedLocker = order && order.lockerNum ? order.lockerNum : ""
      this.setState({ isOpenedDoor: true, openedLocker })
      this.props.setShipingPackageLoading()
      const serviceName = newProps.history.location.state

      if (
        order.orderType === 21 ||
        (order.orderType === 31 && serviceName != "returnsAdidas") ||
        order.orderType === 33 ||
        order.orderType === 37
      ) {
        console.log(
          "oneProject or ReturnsExternal returnPackageOrder  orderId:" +
            order.orderId +
            "  locationId:" +
            order.locationId
        )
        const orderId = order && order.orderId ? order.orderId : order.id

        this.props.returnPackageOrder(
          orderId,
          order.locationId,
          stationId,
          order.lockerNum,
          lockersWithOpenStatusFromHw.toString() //optionalWrongDoor
        )

        return
      }

      order.orderType =
        providerManager.isProvider(serviceName) &&
        (!order.orderType || order.orderType == 0)
          ? providerManager.orderType(serviceName)
          : order.orderType

      order.accountType =
        providerManager.isProvider(serviceName) &&
        (!order.accountType || order.accountType == 0)
          ? providerManager.accountType(serviceName)
          : order.accountType

      this.props.createShipingPackageOrder({
        ...order,
        stationId,
        optionalWrongDoor: lockersWithOpenStatusFromHw.toString(),
      })

      return
    }

    if (createReturnError) {
      this.setState({ showErrorCreateReturn: true })
      return
    }

    if (
      orderWasLoaded &&
      this.state.isCancelActionPressed &&
      isCustomerCancelReturnOrder
    ) {
      console.log(
        " orderWasLoaded && isCancelActionPressed && isCustomerCancelReturnOrder"
      )

      //const serviceName = this.props.history.location.state
      //const { order } = this.props

      //if (order && (order.orderType === 31 ||  order.orderType === 21 ||  order.orderType === 33 ||  order.orderType === 37) ) {
      console.log("isCellClickWaiting: false")
      this.setState({ isCellClickWaiting: false, isOpenedDoor: false })
      //this.props.history.push("/ShipingPackageScreen/DeliverySmsLogin",serviceName)
      //return
      //}

      return
    }
    console.log(
      " *********@ orderWasLoaded: " +
        orderWasLoaded +
        ", isCancelActionPressed:" +
        this.state.isCancelActionPressed +
        ", isCustomerCancelReturnOrder: " +
        isCustomerCancelReturnOrder
    )
    if (
      orderWasLoaded &&
      this.state.isCancelActionPressed &&
      !isCustomerCancelReturnOrder
    ) {
      //Cancel order put_order
      console.log(" *********@ CANCEL  ")

      console.log(
        "orderWasLoaded && isCancelActionPressed && !isCustomerCancelReturnOrder"
      )
      const { stationId } = this.props
      this.props.onLoading_CancelOrderByCustomer()
      this.props.onCustomerReturnOrderCancel(this.props.order, stationId)

      this.setState({
        isClickWaiting: false,
        showYesNoInfoModal: false,
        isOpenedDoor: false,
        openedLocker: "",
        selectedOrderId: null,
        lockerId: null,
        lastOpenDoorSuccessLockerNum: null,
        //lastOpenDoorSuccessLockerNum: notifyServerCustomerPutOrder ? lastOpenDoorSuccessLockerNum :null,
      })
      return
    }

    if (orderWasLoaded && !this.state.isCancelActionPressed) {
      this.props.setThankYouSubTitle(see_you_again)
      console.log("ShipmentReceiveProps goto ThankYouScreen")

      this.props.history.push("/ThankYouScreen")
      return
    }

    if (openingErrorOccurred && !this.state.isOpenedDoor) {
      this.clearWait()
      this.setState({ showDoorOpenErrorModal: true })
    }

    if (
      !isLoading &&
      this.state.isCancelActionPressed &&
      isCustomerCancelReturnOrder
    ) {
      console.log("    RELEASE AFTER CANCEL")
      this.setState({
        isCellClickWaiting: false,
        isCancelActionPressed: false,
        isOpenedDoor: false,
      })

      //const serviceName = this.props.history.location.state
      //if (
      //  providerManager.accountType(serviceName) === 2 || //DHL
      //  providerManager.accountType(serviceName) === 100 //Adidas
      //) {
      //this.props.history.push(  "/ShipingPackageScreen/SenderDetails",serviceName )
      // return
      //}
    }
  }

  checkIsWaiting() {
    if (this.state.isCellClickWaiting) {
      return true
    }
    return false
  }

  isWaiting(num, wait) {
    if (wait && this.state.isCellClickWaiting) {
      console.log(".......isWaiting: " + wait)
      return true
    }

    this.setState({
      ...this.state,
      isCellClickWaiting: wait,
      isCancelActionPressed: false,
      isOpenedDoor: false,
    })
    console.log(".......isWaiting: " + wait)
    return wait
  }

  onCellClick(cellNum, lockerData) {
    if (lockerData === undefined) {
      return
    }

    const { disabled } = lockerData
    if (disabled) {
      return
    }
    const { isLoading, isOrderConfirmed, stationId } = this.props
    if (isLoading || isOrderConfirmed) {
      return
    }

    if (this.checkIsWaiting()) return

    let { order, createdOrder } = this.props

    if (!order) {
      this.props.reportFBEvent(
        "SHIPING_PACKAGE SelectLocker",
        "The order is null. "
      )
      if (!createdOrder) {
        this.props.reportFBEvent(
          "SHIPING_PACKAGE SelectLocker",
          "The order and createdOrder is null. Redirect homepage."
        )
        console.log(
          "onCellClick - The order and createdOrder is null. Redirect homepage."
        )

        this.props.history.push("/")
      }
      return
    }

    this.isWaiting(cellNum, true)
    order.lockerNum = cellNum
    order.locationId = lockerData.lockerId
    console.log(
      "onCellClick - order.packageNumber: " +
        order.packageNumber +
        ", order.lockerNum" +
        order.lockerNum
    )
    const { stationPaymentVersion } = this.props
    console.log("order:")
    console.log(order)

    this.props.setShipingPackageOrder(order)
    this.props.openAndListenToSpecificLockerLock(
      cellNum,
      undefined,
      stationId,
      order.packageNumber,
      2, //it's lockerStatus (2 means 'full', 3 means 'empty')
      stationPaymentVersion
    )
  }

  onDoorOpenErrModalClose() {
    this.setState({
      showDoorOpenErrorModal: false,
      clickedLocker: null,
      isCellClickWaiting: false,
    })
    this.props.resetLockersErrorsAttemptsOpened()
  }

  closeWaitingForLockModal(notifyServerCustomerPutOrder) {
    //Show Cancel order put_order
    this.setState({
      isCancelActionPressed: true,
      showPutToLockerCanceled: true,
      isOpenedDoor: false,
      clickedLocker: null,
    })
  }

  closePutToLockerCanceledModal() {
    this.setState({ showPutToLockerCanceled: false })
  }

  anotherTryPutToLocker() {
    this.setState({
      isCancelActionPressed: true,
      showPutToLockerCanceled: true,
      isOpenedDoor: false,
      clickedLocker: null,
      isCellClickWaiting: false,
    })
  }

  render() {
    const {
      blinkers,
      errLockers,
      opening_locker_number,
      waitingForLockerLockTitle,
      pls_close_door,
      err_while_opening_door,
      try_another_locker_or_contact_support,
      close_text,
      please_wait,
      openAttemptsNum,
      dirRtl,
      order,
      choose_locker,
      put_to_locker_canceled_title,
      put_to_locker_canceled_body,
      create_return_failed_title,
      create_return_failed_body,
      cancel_operation,
      closing_door_is_not_recognized_click_here,
      barcode_text,
      btn_one_more_try,
    } = this.props

    const {
      showDoorOpenErrorModal,
      isOpenedDoor,
      openedLocker,
      showPutToLockerCanceled,
      showErrorCreateReturn,
    } = this.state

    let onOopsClicked = false
    const serviceName = this.props.history.location.state
    if (
      providerManager.isProvider(serviceName) &&
      (providerManager.accountType(serviceName) === 2 || //DHL
        providerManager.accountType(serviceName) === 100) //Adidas
    ) {
      onOopsClicked = () => this.closeWaitingForLockModal(false)
    }
    if (
      order &&
      (order.orderType === 31 || //ReturnsExternal,
        order.orderType === 21 || //OneProject,
        order.orderType === 33 || //DeliveryReturnsUPS
        order.orderType === 37) //DeliveryReturnsZigZag
    ) {
      onOopsClicked = () => this.closeWaitingForLockModal(false)
    }

    let { lockerNum } = 11111
    if (order && order.lockerNum !== undefined && order.lockerNum != null) {
      lockerNum = order.lockerNum
    }
    return (
      <>
        <div className="ls-wrapper ">
          <FixedHeader buttonsFlag="unlockLockersScreen" />
          <div className="rent-locker-title">{choose_locker}</div>

          <div className="ddocs-inner-wrapper">
            <LockerCells
              onCellClick={this.onCellClick.bind(this)}
              blinkers={blinkers}
              errLockers={errLockers}
              hideInfo={true}
              shipingPackage={true}
            />
          </div>
          <FixedFooter history={this.props.history} />
        </div>
        <LoadingInfoModal
          dirRtl={dirRtl}
          show={openAttemptsNum > 0 && !showDoorOpenErrorModal}
          title={opening_locker_number.replace("{XYZ}", lockerNum)}
          text={please_wait}
        />
        <WaitingForLockerLock
          dirRtl={dirRtl}
          show={isOpenedDoor}
          title={waitingForLockerLockTitle.replace("{XYZ}", openedLocker)}
          subTitle={pls_close_door}
          onOopsClicked={onOopsClicked}
          cancelText={cancel_operation}
          notRecognizedCloseText={closing_door_is_not_recognized_click_here}
          barcodeTitle={barcode_text}
        />
        <ErrorInfoModal
          dirRtl={dirRtl}
          show={showDoorOpenErrorModal}
          title={err_while_opening_door}
          text={try_another_locker_or_contact_support.replace(
            "{XYZ}",
            lockerNum
          )}
          onModalCloseClick={() => this.onDoorOpenErrModalClose()}
          closeTrnsl={close_text}
        />
        <WarningInfoModal
          show={showPutToLockerCanceled}
          title={put_to_locker_canceled_title}
          text={put_to_locker_canceled_body}
          onModalCloseClick={() => this.closePutToLockerCanceledModal()}
          btnText={close_text}
        />
        <WarningInfoModal
          show={showErrorCreateReturn}
          title={create_return_failed_title}
          text={create_return_failed_body}
          onModalCloseClick={() => {
            //TODO CLOSE AND OUT
            this.setState({ showErrorCreateReturn: false })
            this.props.history.push("/ServiceDeliveryMenuScreen")
          }}
          btnText={close_text}
          dirRtl={dirRtl}
        />
      </>
    )
  }
}

const mapStateToProps = ({
  lockersCells,
  translate,
  bgService,
  shipingPackage,
  stationServiceTypes,
}) => {
  const {
    openedLockersArr,
    errorLockersArr,
    openingAttempsMap,
    recentClosedLockersArr,
    lockersWithOpenStatusFromHw,
    brokenLockersNumArr,
  } = lockersCells
  const {
    dirRtl,
    driver_menu_lockers_cells_opening,
    driver_lockers_cells_opening_subtitle,
    please_wait,
    opening_locker_number,
    on_order_collection_finish,
    pls_close_door,
    try_another_locker_or_contact_support,
    err_while_opening_door,
    close_text,
    choose_locker,
    put_to_locker_canceled_title,
    put_to_locker_canceled_body,
    cancel_operation,
    create_return_failed_title,
    create_return_failed_body,
    closing_door_is_not_recognized_click_here,
    barcode_text,
    btn_one_more_try,
  } = translate

  const { stationPaymentVersion } = stationServiceTypes

  const waitingForLockerLockTitle = `${opening_locker_number}. ${on_order_collection_finish}`

  const { stationId, stationNumber } = bgService
  const {
    order,
    createdOrder,
    isLoading,
    createReturnError,
    isCustomerCancelReturnOrder,
  } = shipingPackage

  const { lockerNum } = order || {}
  const openingDoorSuccess = openedLockersArr.includes(lockerNum)
  const openingErrorOccurred = errorLockersArr.includes(lockerNum)
  const orderWasLoaded =
    createdOrder && recentClosedLockersArr.includes(createdOrder.lockerNum)
  const openAttemptsNum = openingAttempsMap[lockerNum] || 0
  const blinkers = !openingErrorOccurred ? { [lockerNum]: lockerNum } : {}
  const errLockers = openingErrorOccurred ? { [lockerNum]: lockerNum } : {}

  return {
    stationPaymentVersion,
    blinkers,
    errLockers,
    openingDoorSuccess,
    openingErrorOccurred,
    orderWasLoaded,
    openAttemptsNum,
    brokenLockersNumArr,
    driver_menu_lockers_cells_opening,
    driver_lockers_cells_opening_subtitle,
    opening_locker_number,
    stationId,
    order,
    createdOrder,
    dirRtl,
    please_wait,
    waitingForLockerLockTitle,
    pls_close_door,
    try_another_locker_or_contact_support,
    err_while_opening_door,
    close_text,
    lockersWithOpenStatusFromHw,
    isLoading,
    choose_locker,
    put_to_locker_canceled_title,
    put_to_locker_canceled_body,
    cancel_operation,
    createReturnError,
    create_return_failed_title,
    create_return_failed_body,
    closing_door_is_not_recognized_click_here,
    barcode_text,
    isCustomerCancelReturnOrder,
    btn_one_more_try,
    stationNumber,
  }
}

export default connect(mapStateToProps, {
  LogoutUser,
  reportFBEvent,
  logScreenEnterance,
  setShipingPackageOrder,
  createShipingPackageOrder,
  openAndListenToSpecificLockerLock,
  resetLockersErrorsAttemptsOpened,
  setThankYouSubTitle,
  setShipingPackageLoading,
  clearShipingPackage,
  returnPackageOrder,
  onLoading_CancelOrderByCustomer,
  onCustomerReturnOrderCancel,
  validateShipingPackageNumber,
  validateAdidasPackageNumber,
})(withRouter(ShipingPackageSelectLocker))
